import { render, staticRenderFns } from "./o12.vue?vue&type=template&id=0395870a&scoped=true&"
import script from "./o12.vue?vue&type=script&lang=js&"
export * from "./o12.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0395870a",
  null
  
)

export default component.exports